'use strict';

var _extends = require('@babel/runtime/helpers/extends');

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');

var React = require('react');

var injectSheet = require('react-jss');

var THEME = require('pobble-components/dist/theme');

var jssMixins = require('pobble-components/dist/jss-mixins');

var PropTypes = require('prop-types');

var LockIcon = require('react-icons/lib/fa/lock');

var classNames = require('classnames');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _extends__default =
/*#__PURE__*/
_interopDefaultLegacy(_extends);

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var _objectWithoutProperties__default =
/*#__PURE__*/
_interopDefaultLegacy(_objectWithoutProperties);

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

var PropTypes__default =
/*#__PURE__*/
_interopDefaultLegacy(PropTypes);

var LockIcon__default =
/*#__PURE__*/
_interopDefaultLegacy(LockIcon);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var FONT_SIZES = THEME__default["default"].FONT_SIZES,
    COLORS = THEME__default["default"].COLORS;
var styles = {
  selectHolder: {
    position: 'relative'
  },
  big: {
    '& select': {
      height: '50px',
      padding: '12px 20px',
      fontSize: '20px',
      lineHeight: '20px'
    },
    '& $arrowIcon': {
      width: '15px',
      top: '22px',
      right: '12px'
    }
  },
  camo: {
    '& $select': {
      borderColor: 'transparent'
    }
  },
  contrast: {
    '& $select': {
      borderColor: 'transparent',
      background: 'rgba(255, 255, 255, .15)',
      color: '#fff',
      '&:hover': {
        borderColor: 'transparent',
        '& + $arrowIcon': {
          color: '#fff'
        }
      }
    },
    '& $arrowIcon': {
      color: '#fff',
      '&:hover': {
        color: '#fff'
      }
    }
  },
  invalid: {
    '& $select': _objectSpread(_objectSpread({
      borderColor: COLORS.RED.NORMAL,
      backgroundColor: '#FEF7F6'
    }, jssMixins.hover({
      borderColor: COLORS.RED.NORMAL,
      '& + $arrowIcon': {
        color: COLORS.RED.NORMAL
      }
    })), {}, {
      '& + $arrowIcon': {
        color: COLORS.RED.NORMAL
      }
    })
  },
  disabled: {
    '& $select': {
      cursor: 'default',
      backgroundColor: '#F9F9F9',
      borderColor: '#ECECEC !important'
    }
  },
  arrowIcon: {
    color: '#787878',
    transition: 'color 0.3s',
    position: 'absolute',
    right: '11px',
    top: '18px',
    pointerEvents: 'none'
  },
  lockIcon: {
    color: '#797979',
    position: 'absolute',
    right: '10px',
    top: '14px',
    pointerEvents: 'none'
  },
  select: _objectSpread(_objectSpread({
    whiteSpace: 'nowrap',
    transition: 'border-color 0.3s',
    cursor: 'pointer',
    appearance: 'none',
    background: 'none',
    outline: 'none',
    border: '1px solid #ddd',
    borderRadius: '4px',
    height: '40px',
    display: 'block',
    width: '100%',
    padding: '0 34px 0 15px'
  }, FONT_SIZES.BODY_DEFAULT.STYLE), {}, {
    color: COLORS.TEXT.MID_GREY.NORMAL
  }, jssMixins.hover({
    borderColor: COLORS.BLUE.NORMAL,
    '& + $arrowIcon': {
      color: COLORS.BLUE.NORMAL
    }
  }))
};

var Arrow = function Arrow(_ref) {
  var className = _ref.className;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("svg", {
      className: className,
      width: "11",
      height: "7",
      viewBox: "0 0 11 7",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React__default["default"].createElement("g", {
      id: "Style-Guide",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round"
    },
    /*#__PURE__*/
    React__default["default"].createElement("g", {
      id: "Input-fields-and-dropdowns",
      transform: "translate(-1445 -214)",
      stroke: "currentColor"
    },
    /*#__PURE__*/
    React__default["default"].createElement("g", {
      id: "Default-dropdown",
      transform: "translate(1254 129)"
    },
    /*#__PURE__*/
    React__default["default"].createElement("g", {
      id: "Down-arrow---active",
      transform: "translate(191 86)"
    },
    /*#__PURE__*/
    React__default["default"].createElement("path", {
      d: "M0.14957265,0.138888889 L5.23504274,4.86111111",
      id: "Line-2"
    }),
    /*#__PURE__*/
    React__default["default"].createElement("path", {
      d: "M10,0 L5.38461538,5",
      id: "Line-2-Copy"
    }))))))
  );
};

var _excluded = ["classes", "value", "name", "children", "id", "big", "onChange", "className", "disabled", "camo", "contrast", "validationError", "selectClassName", "selectProps"];

var FormSelect = function FormSelect(_ref) {
  var _classNames;

  var classes = _ref.classes,
      value = _ref.value,
      name = _ref.name,
      children = _ref.children,
      id = _ref.id,
      big = _ref.big,
      onChange = _ref.onChange,
      className = _ref.className,
      disabled = _ref.disabled,
      camo = _ref.camo,
      contrast = _ref.contrast,
      validationError = _ref.validationError,
      selectClassName = _ref.selectClassName,
      selectProps = _ref.selectProps,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.selectHolder, (_classNames = {}, _defineProperty__default["default"](_classNames, classes.disabled, disabled), _defineProperty__default["default"](_classNames, classes.big, big), _defineProperty__default["default"](_classNames, classes.camo, camo), _defineProperty__default["default"](_classNames, classes.invalid, validationError), _defineProperty__default["default"](_classNames, classes.contrast, contrast), _classNames), className)
    },
    /*#__PURE__*/
    React__default["default"].createElement("select", _extends__default["default"]({
      disabled: disabled,
      value: value,
      name: name,
      onChange: onChange,
      className: classNames__default["default"](classes.select, selectClassName),
      id: id
    }, selectProps, props), children), !disabled &&
    /*#__PURE__*/
    React__default["default"].createElement(Arrow, {
      className: classes.arrowIcon
    }), disabled &&
    /*#__PURE__*/
    React__default["default"].createElement(LockIcon__default["default"], {
      className: classes.lockIcon
    }))
  );
};

FormSelect.propTypes = {
  /** Id of the select DOM node */
  id: PropTypes__default["default"].string,

  /** Boolean value of checked state. Makes radio button controlled */
  value: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number]),

  /** Name of the select */
  name: PropTypes__default["default"].string,
  children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]),

  /** On select change handler */
  onChange: PropTypes__default["default"].func,

  /** Additional className if you want to restyle component */
  className: PropTypes__default["default"].string,

  /** Disable select */
  disabled: PropTypes__default["default"].bool,

  /** Set of options for select element */
  selectProps: PropTypes__default["default"].object
};
var index = injectSheet__default["default"](styles)(FormSelect);
module.exports = index;